import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5abeaa15"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "profile-picture" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "name" }
const _hoisted_4 = { class: "presence" }
const _hoisted_5 = { class: "routing-status" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["member-container", [`p-${_ctx.presence}`, `rs-${_ctx.routingStatus}`]])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", { src: _ctx.imageURI }, null, 8, _hoisted_2)
    ]),
    _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.name), 1),
    _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.presence), 1),
    _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.routingStatus), 1)
  ], 2))
}